import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

/**
 * Opens a URL appropriately for the current platform.
 * - Native (Android/iOS): uses Capacitor Browser plugin (Chrome Custom Tabs / SFSafariViewController)
 * - Web/PWA: falls back to window.location.href
 */
export async function openExternalUrl(url, { newTab = false } = {}) {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url });
  } else {
    if (newTab) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = url;
    }
  }
}

/**
 * Adds a one-shot listener for when the Capacitor in-app browser is closed.
 * On web this is a no-op since there is no Browser plugin event.
 * Returns a cleanup function that removes the listener.
 */
export function onBrowserFinished(callback) {
  if (!Capacitor.isNativePlatform()) {
    return () => {};
  }

  let handle = null;

  Browser.addListener('browserFinished', () => {
    callback();
  }).then((listenerHandle) => {
    handle = listenerHandle;
  });

  return () => {
    if (handle) handle.remove();
  };
}
